/**
 * Copyright (c) 2026, CheckPlus Limited
 */
import React, { Component } from "react";
import "./ZhRix.css";
import { Link } from "react-router-dom";
import { renderHomePageHeader } from "../../assets/component/renderHomePageHeader.js";
import { Helmet } from "react-helmet";
import HomepageMenuZh from "../../assets/component/HomepageMenuZh/HomepageMenuZh.js";

class ZhRix extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showModal: false,
    };
    this.showModal = this.showModal.bind(this);
    this.closeModal = this.closeModal.bind(this);
  }
  componentDidMount() {
    window.scrollTo(0, 0);
  }
  showModal() {
    this.setState({
      showModal: true,
    });
  }

  closeModal() {
    this.setState({
      showModal: false,
    });
  }
  render() {
    return (
      <div className="ZhRix-view">
        <Helmet>
          <title>創辦人 - 賴鈞庭 - CheckPlus</title>
        </Helmet>
        {!!this.state.showModal && (
          <HomepageMenuZh closeModal={this.closeModal} />
        )}
        {renderHomePageHeader(this)}

        <div className="ZhRix-first">
          <Link to="/ZhTeam">
            <div className="ZhRix-back">
              <div className="ZhRix-backBtn"></div>
              <div className="ZhRix-backText">返回</div>
            </div>
          </Link>

          <div className="ZhRixContainer">
            <div className="ZhRix-rixPic" />

            <div className="ZhRix-name">
              <strong>賴鈞庭 Rix Lai </strong>
              <br />
              創辦人
            </div>
          </div>
        </div>

        <div className="ZhRix-second">
          <div className="ZhRix-secondText">
            賴鈞庭 Rix Lai 是 CheckPlus 的創辦人。
            <p />
            Rix了解在正確的項目中使用正確技術的重要性。
            <p />
            在成立 CheckPlus 之前， 他大部分時間都在學習如何從年輕時開始編碼。
            憑藉他在技術領域的專業知識和經驗，他早期與 CheckPlus
            的產品開發團隊合作。
            <p />
            Rix 獲得加州大學聖地亞哥分校的電腦科學學士學位。
          </div>
        </div>

        <div className="ZhRix-footer">
          <div className="ZhRix-footerNav">
            <Link to="/ZhTeam">
              <div className="ZhRix-footerNavItem">創辦人的故事</div>
            </Link>
            <Link to="/ZhFaq">
              <div className="ZhRix-footerNavItem">常見問題</div>
            </Link>
            <Link to="/ZhContact">
              <div className="ZhRix-footerNavItem">聯絡我們</div>
            </Link>

            <Link to="/ZhPrivacyPolicy">
              <div className="ZhRix-footerNavItem">私隱政策</div>
            </Link>

            <Link to="/ZhTerms">
              <div className="ZhRix-footerNavItem">使用條款</div>
            </Link>
          </div>

          <div className="ZhRix-footer_text">
            香港九龍油塘四山街 11 號
            <br />
            華利工業大廈 5 樓 A 室
            <br />
            <p />
            Copyright © 2026 CheckPlus Ltd. 保留一切權利。
          </div>
        </div>
      </div>
    );
  }
}

export default ZhRix;
